export default "__VITE_ASSET__iKF5mpSO__"